function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m43.8667 29.3334c0-.4.1333-.9333.1333-1.3333 0-1.4667 0-7.8667 0-9.3334 0-10.13331-24-6.6666-24 0v9.3334c0 .4 0 .9333.1333 1.3333z",
  fill: "#ffb74d"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m53.3333 58.6667h-42.6666c-2.93337 0-5.33337-2.4-5.33337-5.3333v-18.6667c0-2.9333 2.4-5.3333 5.33337-5.3333h42.6666c2.9334 0 5.3334 2.4 5.3334 5.3333v18.6667c0 2.9333-2.4 5.3333-5.3334 5.3333z",
  fill: "#37474f"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m9.33333 34.6667v18.6667c0 .8.53333 1.3333 1.33337 1.3333h38.6666c.8 0 1.3334-.5333 1.3334-1.3333v-18.6667c0-.8-.5334-1.3333-1.3334-1.3333h-38.6666c-.80004 0-1.33337.5333-1.33337 1.3333z",
  fill: "#bbdefb"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m56 40h-2.6667v8h2.6667z",
  fill: "#78909c"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m36 42.6666h-10.6667v12h10.6667z",
  fill: "#bf360c"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m34 50h-6.6667v4.6667h6.6667z",
  fill: "#ff9800"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m36.6667 42.6666c0-5.0667-12-3.3333-12 0v4.6667c0 3.3333 2.6666 6 6 6 3.3333 0 6-2.6667 6-6 0-.6667 0-4 0-4.6667z",
  fill: "#ffb74d"
});

var _ref9 = /*#__PURE__*/React.createElement("g", {
  fill: "#784719"
}, /*#__PURE__*/React.createElement("path", {
  d: "m37.3333 29.3333c.7364 0 1.3334-.597 1.3334-1.3333 0-.7364-.597-1.3334-1.3334-1.3334-.7363 0-1.3333.597-1.3333 1.3334 0 .7363.597 1.3333 1.3333 1.3333z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m26.6667 29.3333c.7363 0 1.3333-.597 1.3333-1.3333 0-.7364-.597-1.3334-1.3333-1.3334-.7364 0-1.3334.597-1.3334 1.3334 0 .7363.597 1.3333 1.3334 1.3333z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m33.3333 48c.3682 0 .6667-.2985.6667-.6667s-.2985-.6667-.6667-.6667-.6666.2985-.6666.6667.2984.6667.6666.6667z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m28 48c.3682 0 .6667-.2985.6667-.6667s-.2985-.6667-.6667-.6667-.6667.2985-.6667.6667.2985.6667.6667.6667z"
}));

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m30.6667 36c-4 0-10.6667 1.7333-10.6667 14.6667l5.3333 4v-8.6667l8-4.6667 2.6667 3.3334v10l5.3333-4c0-2.6667-1.0666-13.3334-8-13.3334l-.6666-1.3333z",
  fill: "#ff5722"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m21.3333 29.3334v-4l16-9.3334 5.3334 6.6667v6.6667h9.0666c-.6666-8.2667-3.6-21.33336-14.4-21.33336l-1.3333-2.66667h-4c-7.3333 0-17.7333 3.73334-19.7333 24.00003z",
  fill: "#ff5722"
});

const SvgSelfie = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 64,
    viewBox: "0 0 64 64",
    width: 64,
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSelfie, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/selfie.1ba677b2.svg";
export { ForwardRef as ReactComponent };